import { Injectable } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Observable, EMPTY } from 'rxjs';
import { AuthContext } from '../../models/auth-context';
import { LocalStorageService } from '../../../../services/local-storage-service/local-storage.service';
import { AppSettings } from '../../../../utils/app-settings';

@Injectable({
  providedIn: 'root'
})
export class WebAuthContextService extends AuthService {
  constructor(private localStorageService: LocalStorageService) {
    super();
  }

  authContext$: Observable<AuthContext>;
  getAuthContext(): Observable<AuthContext> {
    return null;
  }
  login(username: string, password: string): Observable<AuthContext> {
    return null;
  }
  logout(): Observable<any> {
    window.location.href = '/Login.aspx';
    return EMPTY
  }
  setPersonContext(authContext: AuthContext) {
    return null
  }
}
